import React from 'react';
import { HeroSection } from './components/HeroSection';
import { UnifiedTestimonialsSection } from './components/UnifiedTestimonialsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { VisualizationSection } from './components/VisualizationSection';
import { AlexaMessageSection } from './components/AlexaMessageSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="w-full min-h-screen bg-[#0D0D0D]" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <HeroSection data-id="element-2" />
      <UnifiedTestimonialsSection data-id="element-3" />
      <BenefitsSection data-id="element-4" />
      <VisualizationSection data-id="element-5" />
      <AlexaMessageSection data-id="element-6" />
      <ClosingSection data-id="element-7" />
      <Footer data-id="element-8" />
      <StickyCTA data-id="element-9" />
    </div>;
}